export const isMediaImage = (mime?: string) => mime?.includes("image")